import api from './axios.service';
import { uploadFile } from './upload.service';
const axios = api;

const getSongs = async (query={}) => {
    try {
        let url = `/songs`;
        if ('category' in query && query.category) {
            url += `?category=${query.category}`;
        }

        let response = await axios.get(url);
        return response.data;
    } catch (error) {
        return error?.response?.data || { error: error.message };
    }
}

const getSong = async (id) => {
    try {
        let response = await axios.get(`/songs/${id}`);
        return response.data;
    } catch (error) {
        return error?.response?.data || { error: error.message };
    }
}

const addSong = async (payload) => {
    try {

        // If 'audio_source' is 'audio_upload' and payload has 'audio_file' field, then we need to upload the audio file using multipart/form-data and get the link to the uploaded audio file
        let uploadRes = null;
        if (payload.audio_source == 'audio_upload' && payload.audio_file) {
            if (payload.audio_file) {
                uploadRes = await uploadFile({ file: payload.audio_file });
                if (uploadRes?.error) {
                    return { error: "Error uploading audio file: " + uploadRes.error };
                }
                payload.audio_file = uploadRes.file;
            }
        }
        if (payload.audio_source == 'audio_upload' && payload.cover_image) {
            if (payload.cover_image) {
                uploadRes = await uploadFile({ file: payload.cover_image });
                if (uploadRes?.error) {
                    return { error: "Error uploading cover image file: " + uploadRes.error };
                }
                payload.cover_image = uploadRes.file;
            }
        }


        let response = await axios.post(`/songs`, payload);
        return response.data;
    } catch (error) {
        return error?.response?.data || { error: error.message };
    }
}

const updateSong = async (id, payload) => {
    try {

        // If 'audio_source' is 'audio_upload' and payload has 'audio_file' field, then we need to upload the audio file using multipart/form-data and get the link to the uploaded audio file
        let uploadRes = null;
        if (payload.audio_source == 'audio_upload' && (payload.audio_file && typeof payload.audio_file === 'object' && payload.audio_file instanceof File)) {
            uploadRes = await uploadFile({ file: payload.audio_file });
            if (uploadRes?.error) {
                return { error: "Error uploading audio file: " + uploadRes.error };
            }
            payload.audio_file = uploadRes.file;
        }
        if (payload.cover_image && typeof payload.cover_image === 'object' && payload.cover_image instanceof File) {
            uploadRes = await uploadFile({ file: payload.cover_image });
            if (uploadRes?.error) {
                return { error: "Error uploading cover image file: " + uploadRes.error };
            }
            payload.cover_image = uploadRes.file;
        }

        let response = await axios.patch(`/songs/${id}`, payload);
        return response.data;
    } catch (error) {
        return error?.response?.data || { error: error.message };
    }
}

const deleteSong = async (id) => {
    try {
        let response = await axios.delete(`/songs/${id}`);
        return response.data;
    } catch (error) {
        return error?.response?.data || { error: error.message };
    }
}

export {
    getSongs,
    getSong,
    addSong,
    updateSong,
    deleteSong
};
